import clsx from 'clsx';

import { times } from 'es-toolkit/compat';
import PureBaseComponent from '@tock/shared/components/PureBaseComponent';

interface Props {
  passcode: string;
  maxLength: number;
  error?: boolean;
}

export default class PasscodeDigits extends PureBaseComponent<Props> {
  render() {
    const { passcode, maxLength, error } = this.props;
    return (
      <div className="PasscodeDigits FSHide">
        {times(maxLength, (i) => (
          <div
            key={i}
            className={clsx('PasscodeDigits-digit', {
              'PasscodeDigits-digit--active': i <= passcode.length,
              'PasscodeDigits-digit--error': error,
            })}
          >
            <span>{passcode[i]}</span>
          </div>
        ))}
      </div>
    );
  }
}
